export { default } from './TrendGridItem'
